
<template>

    <div class="skeleton_box">
        <Group :fold="false" v-if="schema.screening.status">
          <div class="skeleton_screening syue-clr">
            <div class="skeleton_field" v-for="n in schema.screening.fieldLength" :key="n">
              <div class="skeleton_label skeleton_bg"></div>
              <div class="skeleton_field_content skeleton_bg"></div>
            </div>
            
          </div>
        </Group>
        <Group :fold="false" v-if="schema.form.status">
          <div class="skeleton_form syue-clr">
            <div class="skeleton_field" v-for="n in schema.form.fieldLength" :key="n">
              <div class="skeleton_label skeleton_bg"></div>
              <div class="skeleton_field_content skeleton_bg"></div>
            </div>
          </div>
        </Group>
        <Group :fold="false" v-if="schema.table.status">
          <div >
            <div class="skeleton_btn_group syue-clr">
              <span class="skeleton_btn" v-for="n in schema.table.btnLength" :key="n"></span>
            </div>
            <table class="skeleton_table syue-clr">
              <tr v-for="n in schema.table.trLength" :key="n">
                <td v-for="z in 4" :key="z"><span class="skeleton_text skeleton_bg"></span></td>
              </tr>
            </table>
          </div>
        </Group>
    </div>
</template>

<script>
import Group from '../group/index.vue'
const PAGECONST = {
  DETAIL: 'detail',
  EDIT: 'edit',
  LIST: 'list'
}
const PAGE = {
  [PAGECONST.LIST]: {
    schema: {
      screening: {
        status: true,
        fieldLength: 3
      },
      form: {
        status: false,
        fieldLength: 10
      },
      table: {
        status: true,
        btnLength: 5,
        trLength: 10
      }
    }
  },
  [PAGECONST.DETAIL]: {
    schema: {
      screening: {
        status: true,
        fieldLength: 3
      },
      form: {
        status: true,
        fieldLength: 10
      },
      table: {
        status: true,
        btnLength: 5,
        trLength: 5
      }
    }
  },
  [PAGECONST.EDIT]: {
    schema: {
      screening: {
        status: true,
        fieldLength: 3
      },
      form: {
        status: true,
        fieldLength: 10
      },
      table: {
        status: true,
        btnLength: 5,
        trLength: 5
      }
    }
  }
}
export default {
  name: 'skeleton',
  props: {
    page: {
      default: PAGECONST.EDIT
    }
  },
  components: [
    Group
  ],
  data () {
    return {
      schema: PAGE[this.page].schema
    }
  }
}
</script>

<style lang="sass" scoped>
@keyframes ant-skeleton-loading {
    0% {
        background-position: 100% 50%
    }

    to {
        background-position: 0 50%
    }
}
.skeleton_box{
  cursor: progress;
  //margin-top: 8px;
  ::v-deep .group-header-title{
    &::after{
      height: 28px;
      background: #f1f6ff;
      content: '\20';
      display: block;
      position: absolute;
      left: 20px;
      border-radius: 4px;
      right: 0;
      top: 0px;
    }
  }
}
.skeleton_screening{
 .skeleton_field{
   
 } 
}
.skeleton_form{
 .skeleton_field{
   padding-top: 30px;
 } 
}
.skeleton_field{
  margin-right: 155px;
  float: left
}
.skeleton_field:nth-child(3n) {
  margin-right: 0px;
}
.skeleton_label{
  width: 138px;
  margin-bottom: 8px;
}
.skeleton_field_content{
  width: 280px;
}
.skeleton_bg{
    height: 28px;
    border-radius: 4px;
    display: block;
    // background: #f1f6ff;
    background: linear-gradient(90deg,rgba(241, 246, 255, 1,) 25%,rgba(232,240,255,1) 37%,rgba(241, 246, 255, 1) 63%);
    background-size: 400% 100%;
    animation: ant-skeleton-loading 1.4s ease infinite;
}

.skeleton_btn_group{
  padding-bottom: 30px;
  font-size: 0px;
  .skeleton_btn{
    margin-right: 16px;
    display: inline-block;
    width: 100px;
    height: 32px;
    background: #f1f6ff;
    border-radius: 4px;
  }
}
.skeleton_table{
  width: 100%;
  td {
    padding: 16px 16px;
    border-top: 1px solid #EFF2F9;
  }
  .skeleton_text skeleton_bg{
    width: 150px;
  }
}
</style>
